<template>
  <div>
    <Row class="container">
      <i-col span="12" offset="2" class="signup-img-box"> </i-col>
      <i-col span="8" class="box">
        <div class="sign-up-title">
          <h1>欢迎注册账号</h1>
        </div>
        <div class="sing-up-step-box">
          <Steps :current="signUpStep">
            <Step title="填写账号信息" icon="person-add"></Step>
            <Step
              title="注册成功"
              icon="ios-checkmark-outline"
              class="right-step"
            ></Step>
          </Steps>
          <div class="sign-up-box">
            <transition mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </i-col>
    </Row>
    <Footer></Footer>
  </div>
</template>

<script>
import store from "../../store";
import { mapState, mapMutations } from "vuex";

export default {
  name: "SignUp",
  data() {
    return {
      index: 0
    };
  },
  computed: {
    ...mapState(["signUpStep"])
  },
  methods: {
    ...mapMutations(["SET_SIGN_UP_SETP"])
  },
  store,
  mounted() {
    this.SET_SIGN_UP_SETP(0);
  }
};
</script>

<style scoped>
.container {
  height: 460px;
  overflow: hidden;
  background-image: url("../../assets/pc/images/home/login.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: -50px;
}
.signup-img-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.signup-img-box > img {
  height: 80%;
}
.sign-up-title {
  width: 430px;
  margin: 15px auto;
  font-size: 16px;
}
.sing-up-step-box {
  margin: 15px auto;
  padding-left: 30px;
  padding-top: 30px;
  width: 430px;
  height: 380px;
  border-radius: 3%;
  background: #fff;
}
.sign-up-box {
  margin: 30px 25px;
  width: 350px;
  display: flex;
  align-items: center;
}
.right-step {
  text-align: center;
  padding-left: 50px;
}
.container /deep/ .ivu-steps .ivu-steps-tail > i {
  width: 160%;
}
h1 {
  color: #fff;
}
</style>
